define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
});

//# sourceMappingURL=IFocusSuggester.js.map
